import type { StagedAction } from '../../hooks/staged-actions/types'

/**
 * The gateway's mark on an action its drafting agent is writing, and how long
 * the mark counts: an agent that dies never clears it. Both match
 * `DRAFTING_SINCE_KEY` and `DRAFTING_TTL_MS` in the gateway's stored-draft.ts.
 */
const DRAFTING_SINCE_KEY = 'plannerV2DraftingSince'
const DRAFTING_TTL_MS = 3 * 60_000

/** When the agent drafting the action stops counting as drafting, or null when none is. */
export function agentDraftingUntil(action: Partial<Pick<StagedAction, 'metadata'>>, now = Date.now()): number | null {
  const since = Date.parse(action.metadata?.[DRAFTING_SINCE_KEY] ?? '')
  if (Number.isNaN(since)) return null
  const until = since + DRAFTING_TTL_MS
  return until > now ? until : null
}
